import { render, staticRenderFns } from "./UiCounter.vue?vue&type=template&id=78a710c3"
import script from "./UiCounter.vue?vue&type=script&lang=js"
export * from "./UiCounter.vue?vue&type=script&lang=js"
import style0 from "./UiCounter.vue?vue&type=style&index=0&id=78a710c3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports